/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Order_Status_Enum =
  | 'closed_but_contested_payment'
  | 'order_archived'
  | 'order_being_paid_by_buyer'
  | 'order_cancelled'
  | 'order_closed'
  | 'order_to_be_billed_by_supplier'
  | 'order_to_be_delivered_by_supplier'
  | 'order_to_be_paid_by_buyer'
  | 'order_to_be_prepared_by_supplier'
  | 'order_to_be_received_by_buyer'
  | 'order_to_be_validated_by_buyer'
  | 'order_to_be_validated_by_supplier';

export type GetOrdersHistoryByContractQueryVariables = Exact<{
  buyingCompanyId: string;
  supplyingCompanyId: string;
}>;


export type GetOrdersHistoryByContractQuery = { order_history: Array<{ id: string, reference_id: string, status: Types.Order_Status_Enum, created_at: string }> };


export const GetOrdersHistoryByContractDocument = /*#__PURE__*/ gql`
    query GetOrdersHistoryByContract($buyingCompanyId: uuid!, $supplyingCompanyId: uuid!) {
  order_history(
    where: {contract: {buyingCompanyId: {_eq: $buyingCompanyId}, supplyingCompanyId: {_eq: $supplyingCompanyId}}, suggestor_id: {_is_null: false}}
    order_by: {reference_id: asc, updated_at: asc}
  ) {
    id
    reference_id
    status
    created_at
  }
}
    `;

/**
 * __useGetOrdersHistoryByContractQuery__
 *
 * To run a query within a React component, call `useGetOrdersHistoryByContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersHistoryByContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersHistoryByContractQuery({
 *   variables: {
 *      buyingCompanyId: // value for 'buyingCompanyId'
 *      supplyingCompanyId: // value for 'supplyingCompanyId'
 *   },
 * });
 */
export function useGetOrdersHistoryByContractQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersHistoryByContractQuery, GetOrdersHistoryByContractQueryVariables> & ({ variables: GetOrdersHistoryByContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersHistoryByContractQuery, GetOrdersHistoryByContractQueryVariables>(GetOrdersHistoryByContractDocument, options);
      }
export function useGetOrdersHistoryByContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersHistoryByContractQuery, GetOrdersHistoryByContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersHistoryByContractQuery, GetOrdersHistoryByContractQueryVariables>(GetOrdersHistoryByContractDocument, options);
        }
// @ts-ignore
export function useGetOrdersHistoryByContractSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrdersHistoryByContractQuery, GetOrdersHistoryByContractQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersHistoryByContractQuery, GetOrdersHistoryByContractQueryVariables>;
export function useGetOrdersHistoryByContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersHistoryByContractQuery, GetOrdersHistoryByContractQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrdersHistoryByContractQuery | undefined, GetOrdersHistoryByContractQueryVariables>;
export function useGetOrdersHistoryByContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersHistoryByContractQuery, GetOrdersHistoryByContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersHistoryByContractQuery, GetOrdersHistoryByContractQueryVariables>(GetOrdersHistoryByContractDocument, options);
        }
export type GetOrdersHistoryByContractQueryHookResult = ReturnType<typeof useGetOrdersHistoryByContractQuery>;
export type GetOrdersHistoryByContractLazyQueryHookResult = ReturnType<typeof useGetOrdersHistoryByContractLazyQuery>;
export type GetOrdersHistoryByContractSuspenseQueryHookResult = ReturnType<typeof useGetOrdersHistoryByContractSuspenseQuery>;
export type GetOrdersHistoryByContractQueryResult = Apollo.QueryResult<GetOrdersHistoryByContractQuery, GetOrdersHistoryByContractQueryVariables>;